import React from 'react'

import PartialCTA from '../partials/cta'

const PricingCard = ({ block }) => {
  if (block.image_position === 'Left') {
    block.image_position_class = 'img-left';
  } else {
    block.image_position_class = 'img-right';
  }

  return (
    <section className={`block ${block._template} ${block.css_class_name ? block.css_class_name : ''} ${block.image_position_class ? ' ' + block.image_position_class : ''} ${block.side_text ? ' has-side-text' : ''} ${block.pricing.length > 4 ? ' ulc-6' : ''} ${!block.image && !block.side_text ? ' fullwidth' : ''}`}>
      {block.background}
      <div className='container'>
        <div className='row'>
          <div className='col-12'>
            <div className='content-wr'>
              <div className='header'>
                {(block.title || block.subtitle) && ( <h3>{block.title} {block.subtitle && (<span>{block.subtitle}</span>)}</h3> )}
                {block.text && ( <div className="text-formatted" dangerouslySetInnerHTML={{__html: block.text}}></div> )}
              </div>
              <div className='row'>
                <div className='pc-col-text text'>
                  <ul className='pricing-wr'>
                    {block.pricing.map((price, index) => {
                      return <li key={index}>
                        <div className='title'>{price.title}</div>
                        <div className='price'>{price.price}</div>
                      </li>
                    })}
                  </ul>
                </div>
                <div className='pc-col-image image'>
                  {block.side_text ? (
                    <div className="side-text" dangerouslySetInnerHTML={{__html: block.side_text}}></div>
                  ) : (
                    block.image && ( <img src={block.image} alt={block.title} title={block.title} /> )
                  ) }
                </div>
              </div>
              <div className='footer'>
                {block.footer_text && ( <div className="text-footer" dangerouslySetInnerHTML={{__html: block.footer_text}}></div> )}
                {block.cta_field && ( <PartialCTA data={block.cta_field} /> )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default PricingCard
